import { graphql, useStaticQuery } from 'gatsby';
export const useAllStaffMembersDevelopment = () => useStaticQuery(graphql `
      query useAllStaffMembersDevelopment {
        cosmos {
          collections {
            people(
              sort: [{ field: order, direction: ASC }]
              where: [{ field: development, operation: eq, value: "true" }, { field: visible, operation: eq, value: "true" }]
            ) {
              name
              position
              management
              order
              bio
              photo_url {
                ticket
                fileName
              }
              alt_photo_url {
                ticket
                fileName
              }
              socials {
                linked_in
                twitter
                instagram
                dribbble
                github
              }
            }
          }
        }
      }
    `).cosmos.collections;
export default useAllStaffMembersDevelopment;
